import { GET_STUDENT_PROFESSIONAL_ADDITIONAL_EDUCATION } from '../../actions';
import { FAILURE, INVALIDATE, REQUEST, SUCCESS } from '../../actions/utils';
import { ICommonResponseObject, IProfessionalAdditionalEducationResponse } from '../../api/types';
import { connectReducers } from '../../utils';
import { IReducers } from '..';
import genericReducers from '../genericReducer';

export type StudentProfessionalAdditionalEducationState =
  ICommonResponseObject<IProfessionalAdditionalEducationResponse>;

const initialState: StudentProfessionalAdditionalEducationState = {
  content: {
    certificate: [],
  },
  loading: false,
};
const generic = genericReducers<StudentProfessionalAdditionalEducationState>();
const studentProfessionalAdditionalEducation: IReducers<StudentProfessionalAdditionalEducationState> = {
  [GET_STUDENT_PROFESSIONAL_ADDITIONAL_EDUCATION[REQUEST]]: generic.get.request,
  [GET_STUDENT_PROFESSIONAL_ADDITIONAL_EDUCATION[SUCCESS]]: generic.get.success,
  [GET_STUDENT_PROFESSIONAL_ADDITIONAL_EDUCATION[FAILURE]]: generic.get.failure,
  [GET_STUDENT_PROFESSIONAL_ADDITIONAL_EDUCATION[INVALIDATE]]: generic.get.invalidate(initialState),
};

export default connectReducers(initialState, studentProfessionalAdditionalEducation);
